import { render, staticRenderFns } from "./ClusterTeams.vue?vue&type=template&id=392048d4&"
import script from "./ClusterTeams.vue?vue&type=script&lang=js&"
export * from "./ClusterTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports